import { Backend } from '.';

export interface TNC {
  id: number;
  title: string;
  body: string;
}

export type TNCs = TNC[];

export interface IndexedTNCs {
  [tncId: number]: TNC;
}

export interface FAQ {
  id: number;
  master_id?: number;
  position: number;
  question: string;
  answer: string;
  children: FAQ[];
}

export type FAQs = FAQ[];

export interface IndexedFAQs {
  [faqId: number]: FAQ;
}

export function getTNC(tncId: number) {
  return Backend.get<TNC>(`/catalog/extra_tncs/${tncId}`);
}

export function getFaq() {
  return Backend.get<IndexedFAQs>('/catalog/faqs');
}
